import React from 'react'
import PropTypes from 'prop-types'
import { Fab as MuiFab, styled } from '@mui/material'

const StyledFab = styled(MuiFab)(({ theme }) => ({
    '& svg:first-child': {
        marginRight: 10,
    },
}))

const Loader = styled('div')({
    marginRight: 10,
})

const ExtendedFab = ({ loading, icon, size, children, ...rest }) => (
    <StyledFab variant="extended" size={size} disabled={loading} {...rest}>
        {loading ? <Loader /> : icon}
        {children}
    </StyledFab>
)

ExtendedFab.propTypes = {
    ...MuiFab.propTypes,
    loading: PropTypes.bool.isRequired,
    icon: PropTypes.any,
}

ExtendedFab.defaultProps = {
    ...MuiFab.defaultProps,
    loading: false,
    size: 'medium',
}

export default ExtendedFab
